import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase, faExchangeAlt, faChartBar, faTags, faCertificate, faUsers, faSitemap, faUserTie, faBoxes, faMapMarkerAlt, faTools, faWallet, faProjectDiagram, faRuler, faTruck, faFileAlt, faLayerGroup, faGasPump, faCalendarCheck, faCoins, faShieldAlt } from '@fortawesome/free-solid-svg-icons';

const moduleIcons = {
  acc: faTools, brand: faTags, category: faLayerGroup, cert: faCertificate,
  customer: faUsers, divisi: faSitemap, employee: faUserTie, equip: faTruck,
  generalitem: faBoxes, itemexpense: faCoins, komoditas: faBoxes, location: faMapMarkerAlt,
  part: faTools, partsub: faTools, pettycash: faWallet, project: faProjectDiagram,
  satuan: faRuler, supp: faTools, suratijin: faFileAlt, vendor: faTruck, zona: faMapMarkerAlt,
  group: faUsers, program: faLayerGroup, user: faShieldAlt, adj: faExchangeAlt,
  saldo: faBoxes, ca: faWallet, costmapping: faSitemap, contract: faFileAlt,
  bast: faFileAlt, bpb: faTruck, bps: faTruck, cm: faExchangeAlt, dailyabsen: faCalendarCheck, fuel: faGasPump,
};
export default function MenuIcon({ program = '', category }) {
  const key = String(program).toLowerCase().replace(/^(mst|adm|hrd|inv|fin|mkt|ops)07/, '').replace(/_(readonly|post)$/, '');
  const icon = category === 'master' ? faDatabase : category === 'transaction' ? faExchangeAlt : category === 'report' ? faChartBar : moduleIcons[key] || faFileAlt;
  return <FontAwesomeIcon icon={icon} className="sap-menu-icon" fixedWidth aria-hidden="true" />;
}
